'use client';

import type { ContactInfo } from '@/lib/algolia/contact';
import { createContext, type ReactNode } from 'react';

export const ContactInfoContext = createContext<ContactInfo | null>(null);

interface ContactInfoProviderProps {
  /** Contact info prefetched in the locale layout (serialized to the client with the RSC payload). */
  initialContact: ContactInfo;
  children: ReactNode;
}

/**
 * Supplies locale contact info via React context.
 *
 * Layout prefetches contact data server-side; context carries it into the client
 * tree without a global store reset on hydration (no default-number flash).
 */
export function ContactInfoProvider({ initialContact, children }: ContactInfoProviderProps) {
  return (
    <ContactInfoContext.Provider value={initialContact}>{children}</ContactInfoContext.Provider>
  );
}
